import React, {
  ButtonHTMLAttributes,
  ComponentType,
  forwardRef,
  ReactNode,
} from 'react';

import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';

import styles from './DropdownMenuItem.module.scss';
import { Button } from '../Button/Button';
import { ButtonSize, ButtonVariant } from '../Button/utils';

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onSelect'> & {
  children: ReactNode;
  size?: ButtonSize;
  isActive?: boolean;
  StartAdornment?: ComponentType;
  EndAdornment?: ComponentType;
  onSelect?: (event: Event) => void;
};

export const DropdownMenuItem = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      disabled,
      isActive,
      size = ButtonSize.MEDIUM,
      StartAdornment,
      EndAdornment,
      className,
      onClick,
      onSelect,
      ...props
    },
    ref,
  ): JSX.Element => {
    return (
      <RadixDropdownMenu.Item asChild disabled={disabled} onSelect={onSelect}>
        <Button
          ref={ref}
          variant={ButtonVariant.TEXT}
          size={size}
          isFullWidth
          disabled={disabled}
          data-active={isActive ? 'true' : undefined}
          className={clsx(styles.item, className)}
          onClick={onClick}
          StartIcon={StartAdornment}
          EndIcon={EndAdornment}
          {...props}
        >
          {children}
        </Button>
      </RadixDropdownMenu.Item>
    );
  },
);

DropdownMenuItem.displayName = 'DropdownMenuItem';
